<form class="app-flex-form" (click)="debugForm(constructor.name)" (keydown)="(null)">
  @for (filter of filters(); track $index) {
    @if (currentFilterView() === filter.label && filter.column === tokenVaultFilterKey.Action) {
      <mat-selection-list [formField]="formTree.action">
        @for (action of tokenVaultActionValues; track $index) {
          <mat-list-option [value]="action" (click)="$event.stopPropagation()">
            {{ action | tokenVaultActionDisplay }}
          </mat-list-option>
        }
      </mat-selection-list>
    } @else if (currentFilterView() === filter.label && filter.column === tokenVaultFilterKey.Status) {
      <mat-selection-list [formField]="formTree.status">
        @for (status of tokenVaultStatusValues; track $index) {
          <mat-list-option [value]="status" (click)="$event.stopPropagation()">
            {{ status | tokenVaultStatusDisplay }}
          </mat-list-option>
        }
      </mat-selection-list>
    } @else if (currentFilterView() === filter.label && filter.column === tokenVaultFilterKey.Verification) {
      <mat-selection-list [formField]="formTree.verification">
        @for (verification of tokenVaultVerificationValues; track $index) {
          <mat-list-option [value]="verification" (click)="$event.stopPropagation()">
            {{ verification | tokenVaultVerificationDisplay }}
          </mat-list-option>
        }
      </mat-selection-list>
    }
  }
</form>
